import React from 'react'
import { graphql } from 'gatsby'
import Banner from '../components/banner'
import Accord from '../components/accord'
import ReactMarkdown from 'react-markdown'

const InterestsPage = ({ data, location }) => {
  return (
    <div>
      <Banner data={data.strapiWhatInterestsUs} credit="Tim Daw" />
      <div className="content-body narrow">
        <h1>{data.strapiWhatInterestsUs.header_part.header}</h1>

        <ReactMarkdown>
          {data.strapiWhatInterestsUs.header_part.description}
        </ReactMarkdown>

        {data.strapiWhatInterestsUs.question_section.map((question_section) => {
          return (
            <Accord
              key={question_section.section_title}
              heading={question_section.section_title}
              opts={question_section.question}
            />
          )
        })}
      </div>
    </div>
  )
}

export const query = graphql`
  query InterestsQuery {
    strapiWhatInterestsUs {
      header_part {
        header
        description
      }

      question_section {
        section_title
        question {
          title
          answer
        }
      }
      mobile_banner {
        ...MobileBannerSizes
      }
      desktop_banner {
        ...DesktopBannerSizes
      }
    }
  }
`

export default InterestsPage
